// extracted by mini-css-extract-plugin
var _1 = "Hm512T04apPbldm1n9kd";
var _2 = "TyXCF3Jdbnp1F1d26Fs_";
export { _1 as "firstParagraph", _2 as "message" }
